import { writable } from "svelte/store";
import * as Sentry from "@sentry/sveltekit";

export type ToastVariant = "success" | "error" | "info";
export interface ToastItem {
	id: number;
	message: string;
	variant: ToastVariant;
}

let nextId = 0;
const DISMISS_MS = 3500;

function createToastStore() {
	const { subscribe, update } = writable<ToastItem[]>([]);

	function push(message: string, variant: ToastVariant = "info") {
		const id = nextId++;
		update((items) => [...items, { id, message, variant }]);
		setTimeout(() => dismiss(id), DISMISS_MS);
	}

	function dismiss(id: number) {
		update((items) => items.filter((t) => t.id !== id));
	}

	return {
		subscribe,
		success: (msg: string) => push(msg, "success"),
		error: (msg: string) => {
			Sentry.captureMessage(msg, { level: "error", tags: { source: "toast" } });
			push(msg, "error");
		},
		info: (msg: string) => push(msg, "info"),
		dismiss,
	};
}

export const toast = createToastStore();
